import { mediaList } from './tableColumns'
import { Media, CashRegisters, FilterComponent } from './'
import { listMedia, getMedia, createMedia, deleteMedia, updateMedia, updateManyMedia } from './gql'
import { routeToMediaTest } from './pages/MediaTest'
import { Monitor, History } from 'media/icons'
import HistoryModal from 'components/HistoryModal'
import { isRouteDisabled } from 'sections/utils'
import listTags from 'gql/query/listTags'
import { loadAppConstants } from 'gql/query'

export default (t, rights, i18n) => ({
	id: '6',
	label: t('media_section.caption'),
	typename: 'Media',
	link: isRouteDisabled(rights, '6') ? null : 'mediacenter',
	linkDisabled: isRouteDisabled(rights, '6'),
	recordsCounter: true,
	icon: Monitor,
	requiredFields: ['name'],
	multiEditConfig: [
		{
			fieldName: 'isActive',
			type: 'checkbox',
			label: t('common.fields.isActive')
		},
		{
			fieldName: 'tagId',
			queryOptions: {
				query: listTags,
				variables: { type: 'MediaTag' }
			},
			type: 'select',
			label: t('media_section.fields.group_tag')
		},
		{
			fieldName: 'animationType',
			queryOptions: {
				query: loadAppConstants,
				variables: { type: 76, language: i18n.language }
			},
			type: 'selectWithoutAdditionalField',
			label: t('media_section.fields.group_tag')
		},
		{
			fieldName: 'refreshTime',
			type: 'numberInput',
			label: t('media_section.strings.img_effect')
		},
		{
			fieldName: 'dateInterval',
			type: 'date',
			label: { from: t('common.fields.from_date'), to: t('common.fields.to_date') }
		},
		{
			fieldName: 'stayActive',
			type: 'checkbox',
			label: t('media_section.fields.stay_active')
		},
		{
			fieldName: 'timeInterval',
			type: 'dateTime',
			label: { from: t('common.fields.from_time'), to: t('common.fields.to_time') }
		},
		{
			fieldName: 'weekDays',
			type: 'weekdayPicker',
			label: t('common.fields.week_days')
		}
	],
	subsections: [{
		name: t('media_section.sub_sections.media'),
		link: '',
		component: Media,
		updateMutation: updateMedia.media,
		fields: ['name', 'isActive', 'animationType', 'refreshTime', 'tagId', 'weekDays', 'stayActive', 'shopId', {
			fieldName: 'dateInterval',
			__typename: 'DateTimeInterval',
			children: ['to', 'from']
		}, {
			fieldName: 'timeInterval',
			__typename: 'DateTimeInterval',
			children: ['to', 'from']
		}, {
			fieldName: 'img',
			__typename: 'Img',
			children: ['id', 'key'],
			noForm: true
		}, {
			fieldName: 'img16_9',
			__typename: 'Img',
			children: ['id', 'key'],
			noForm: true
		}, {
			fieldName: 'imgMobile',
			__typename: 'Img',
			children: ['id', 'key'],
			noForm: true
		}, {
			fieldName: 'withProducts',
			__typename: 'Product',
			isArray: true,
			children: ['id', 'name']
		}]
	}, {
		name: t('common.strings.cash_register_subsection'),
		link: 'kasse',
		component: CashRegisters,
		updateMutation: updateMedia.cashRegisters,
		fields: ['cashRegisterId']
	}],
	itemActions: [{
		label: t('media_section.strings.test_media'),
		// Icon:,
		action: routeToMediaTest
	}, {
		label: t('product_section.strings.update_group'),
		action: ({ multiEdit, data }) => multiEdit.setIsActive(!multiEdit.isActive, data.id)
	}, {
		label: t('common.strings.history'),
		Icon: History,
		modalComponent: HistoryModal
	}],
	columns: mediaList(t),
	listQuery: listMedia,
	itemQuery: getMedia,
	deleteMutation: deleteMedia,
	createMutation: createMedia,
	addNewRecord: true,
	FilterComponent,
	contextTypes: {
		searchCR: 'string'
	},
	multiEditMutation: updateManyMedia
})
